import { Component } from '@angular/core';
import {HeroMorbilidadComponent} from "./hero-morbilidad/hero-morbilidad.component";
import {InfoMorbilidadComponent} from "./info-morbilidad/info-morbilidad.component";
import {FooterPersonaComponent} from "../../app-persona/footer-persona/footer-persona.component";

@Component({
  selector: 'app-morbilidad',
  standalone: true,
  imports: [
    HeroMorbilidadComponent,
    InfoMorbilidadComponent,
    FooterPersonaComponent
  ],
  templateUrl: './morbilidad.component.html',
  styleUrl: './morbilidad.component.css'
})
export class MorbilidadComponent {

}
